import { useSearchParams } from 'react-router-dom'
import { api } from '../api'

export function Login() {
  const [params] = useSearchParams()
  // `?expired=1` se setea desde api.ts cuando un 401 nos patea la sesión.
  // `?error=...` viene del callback del Worker si el SSO falla.
  const expired = params.get('expired') === '1'
  const errorCode = params.get('error')

  let banner: { kind: 'info' | 'danger'; text: string } | null = null
  if (expired) {
    banner = {
      kind: 'info',
      text: 'Tu sesión expiró. Volvé a iniciar sesión con EVE SSO.',
    }
  } else if (errorCode) {
    banner = {
      kind: 'danger',
      text: 'No pudimos completar el login con EVE SSO. Probá de nuevo.',
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="card max-w-md w-full text-center">
        <div className="flex justify-center mb-4">
          <svg width="64" height="64" viewBox="0 0 32 32" className="text-eve-accent">
            <path
              d="M16 4 L28 12 L24 28 L8 28 L4 12 Z"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            />
            <circle cx="16" cy="16" r="4" fill="currentColor" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold mb-2">EVE Dashboard</h1>
        <p className="text-eve-muted mb-6 text-sm">
          Tu panel personal para mining, wallet y finanzas de corp.
          <br />
          Inicia sesión con tu cuenta de EVE Online.
        </p>
        {banner && (
          <div
            role="alert"
            className={`mb-4 text-sm rounded-md px-3 py-2 text-left border ${
              banner.kind === 'danger'
                ? 'border-eve-danger/30 bg-eve-danger/10 text-eve-danger'
                : 'border-eve-accent/30 bg-eve-accent/10 text-eve-accent'
            }`}
          >
            {banner.text}
          </div>
        )}
        <a
          href={api.loginUrl()}
          className="btn-primary inline-block w-full"
        >
          Iniciar sesión con EVE SSO
        </a>
        <p className="text-xs text-eve-muted mt-6">
          Al iniciar sesión autorizás a la app a leer tu wallet, mining,
          skills e industria. Podés revocar el acceso en cualquier momento
          desde tu cuenta de EVE.
        </p>
      </div>
    </div>
  )
}
